import { Button } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const KeyFeaturesSection = () => {
  const { t } = useTranslation();

  return (
    <section className="flex flex-col items-center py-16 px-6 bg-[#EDF6FB] rounded-[30px] max-w-[1204px] mx-auto w-full scroll-mt-[200px] sm:scroll-mt-[330px] lg:scroll-mt-[120px]">
      <div className="flex flex-col justify-center items-start gap-6 w-full max-w-[1200px] h-auto">
        <p className="text-sm font-semibold text-[#0070f3] uppercase">
          {t('keyFeatures.label')}
        </p>
        <h2 className="text-[24px] text-center md:text-left md:text-4xl font-bold text-black leading-tight">
          {t('keyFeatures.title')}
        </h2>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-2 lg:gap-20 justify-items-center w-full max-w-[1200px] mt-10">
        <div className="flex flex-col justify-start items-start w-full max-w-[377px] h-auto rounded-xl gap-[20px]">
          <img
            src="/images/customer-sales-dash.png"
            alt={t('keyFeatures.titleReporting')}
            className="rounded-xl w-full h-[289px] object-cover"
          />
          <div className="bg-[#1a3c5b] text-white p-5 rounded-xl w-full">
            <h3 className="text-[18px] sm:text-[28px] leading-[34px] font-semibold text-white tracking-[-0.04em]">
              {t('keyFeatures.titleReporting')}
            </h3>
            <p className="text-[12px] leading-[18px] sm:text-[16px] sm:leading-[24px] text-[#EDF6FB]">
              {t('keyFeatures.descriptionReporting')}
            </p>
          </div>
        </div>

        <div className="flex flex-col justify-start items-start w-full max-w-[406px] h-auto rounded-xl gap-[20px]">
          <div className="w-full min-h-[130px] p-6 rounded-xl bg-[#005FCC] text-white flex flex-col justify-center gap-[6px]">
            <h3 className="text-lg font-semibold leading-tight">
              {t('keyFeatures.titleFraud')}
            </h3>
            <p className="text-[12px] sm:text-[16px] font-normal leading-[150%] font-inter">
              {t('keyFeatures.descriptionFraud')}
            </p>
          </div>
          <img
            src="/images/credit-cards.png"
            alt={t('keyFeatures.descriptionFraud')}
            className="rounded-xl w-full h-[289px] object-cover"
          />
        </div>

        <div className="flex flex-col justify-start items-start w-full max-w-[377px] h-auto rounded-xl gap-[20px]">
          <img
            src="/images/business-finance-graphs.png"
            alt={t('keyFeatures.titleBackOffice')}
            className="rounded-xl w-full h-[289px] object-cover"
          />
          <div className="bg-white text-black p-5 rounded-xl border border-gray-200 w-full">
            <h3 className="text-[18px] sm:text-[28px] leading-[34px] font-semibold text-[#005FCC] tracking-[-0.04em]">
              {t('keyFeatures.titleBackOffice')}
            </h3>
            <p className="text-[12px] sm:text-[16px] leading-[18px] text-[#232539]">
              {t('keyFeatures.descriptionBackOffice')}
            </p>
          </div>
        </div>
      </div>

      <div className="mt-3">
        <Button
          href="#contact"
          size="large"
          className="w-[250px] lg:w-[406px] h-[48px] px-8 py-3 flex justify-center
          items-center gap-[10px] bg-white text-[#005FCC]
          shadow-[4px_4px_15px_rgba(67,0,153,0.08)] rounded-full
          font-semibold font-archivo text-base"
        >
          {t('common.contact')}
        </Button>
      </div>
    </section>
  );
};
